<div class="wrapper">
  <app-header></app-header>
  <div class="main">
      <div class="container-fluid container-fluid-5">
          <div class="row row5">
              <div class="sidebar col-md-2 hide-small">
                  <app-sidebar></app-sidebar>
              </div>
              <div class="col-12 hide-large featured-box">
              </div>
              <div class="col-md-10 report-main-content m-t-5">

                <!-- start-->

                <div class="bankingUi">
                  <div class="container-fluid">
                     <div class="row">
                       
                        <div class="col-md-8">
                           <div class="row">
                              <div class="col-md-12">
                                 <div>
                                    <div class="col-md-12 card amount-div" *ngIf="!setValue" style="margin-top: 10px;">
                                       <div class="card-body">
                                          <form id="amountForm" method="post">
                                             <input type="hidden" name="_token" value="ys9Q3j3Mv5jULQ703BR6RyhnAIzTqBBb2rOr5ioB">                                            
                                             <div class="form-group">
                                                <label>Amount</label>
                                                <div class="input-group">
                                                   <input type="number" class="form-control" name="amount" id="amount" [(ngModel)]="amount" [ngModelOptions]="{standalone: true}" placeholder="Enter amount">
                                                   <div class="input-group-append">
                                                      <button type="button" class="input-group-text amountBtn" data-wp-add="" (click)="AmountSet()" id="basic-addon2">SUBMIT
                                                      </button>
                                                   </div>
                                                </div>
                                             </div>
                                          </form>
                                       </div>
                                    </div>
                                    <div class="col-md-12 account-list" *ngIf="setValue">
                                      <nav>
                                         <button class="btn btn-primary back_to_amount" data-original-title="" title="" (click)="setValue=false">< Back</button>
                                         <div class="nav nav-tabs" id="nav-tab" role="tablist" style="overflow: hidden;overflow-x: scroll;">
                                           <a href="https://wa.link/servid">
                                             <button type="button" class="nav-link"  data-original-title="" title="">
                                                Whatsapp Deposit
                                                <img src="https://reddybook.blue/images/icon/whatsapp.png" width="5%">
                                                </button>
                                           </a> 
                                            <button *ngFor="let list of payMethodList;let i = index;"  (click)="detail(list)" class="nav-link " [class.active]='list?._id == payDetails?._id' id="nav-bank-account-162225-tab" type="button" role="tab" aria-controls="nav-bank-account-162225" aria-selected="false" data-original-title="" title="">{{list?.name}} <img src="assets/bank_logo/{{list?.payment_type}}.png" width="5%">
                                            </button>
                                           
                                           
                                         </div>
                                      </nav>
                                      <div class="tab-content" id="nav-tabContent">
                                         <div class="tab-pane fade show active" id="nav-bank-account-162225" role="tabpanel" aria-labelledby="nav-home-tab">
                                            <div class="row">
                                               <div class="col-md-12">
                                                  <div class="card">
                                                     <div class="card-body" *ngIf="payDetails">
                                                        <h5 class="card-title" data-min="100.0000" data-max="100000.0000" id="account-name-162225">{{payDetails?.name}}
                                                        </h5>
                                                        <div class="row">
                                                          <div class="col-md-6" *ngIf="payDetails">
                                                            <div class="row justify-content-center">
                                                                <div class="col-md-11">
                                                                    <div class="account-data">
                                                                        <p class="card-text" *ngFor="let detail of payDetails?.payment_details; let i = index;">
                                                                            <b>{{detail?.key}}</b>
                                                                            : {{detail?.value}}

                                                                            <button class="btn btn-sm btn-success" data-clipboard-text="vishal gautam" data-original-title="" title="">
                                                                              <img _ngcontent-serverapp-c305="" (click)="copyToClipboard(detail?.value)" class="support-img" src="assets/copy.png" width="15%">
                                                                            </button>
                                                                        </p>

                                                                        <p class="card-text" >
                                                                          <b>Min</b>
                                                                          :  {{selectData?.min_amount}}
                                                                          
                                                                      </p>

                                                                      <p class="card-text" >
                                                                        <b>Max</b>
                                                                        :  {{selectData?.max_amount}}
                                                                        
                                                                    </p>
                                                                        
                                                                    <img *ngIf="payDetails?.payment_type==5" class="qr-code" src="{{Base_Url}}wallets/{{ payDetails?.image }}">
                                                                                                                            </div>
                                                                </div>
                                                               
                                                                 <div class="col-md-11">
                                                                        <a href="https://wa.link/servid" target="_blank">
                                                                            <div class="card">
                                                                                <div class="card-body payment-issues">
                                                                                    <p><b>FOR PAYMENT RELATED ISSUES
                                                                                            CLICK HERE</b>
                                                                                        &nbsp;&nbsp;<img _ngcontent-serverapp-c305="" src="https://reddybook.blue/images/icon/whatsapp.png" width="15%">
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                                                            </div>
                                                        </div>


                                                           <div class="col-md-6">
                                                              <form id="bankDepositForm162225" method="post" action="https://reddybook.blue/store-deposit/param/param1/param2" enctype="multipart/form-data" novalidate="novalidate">
                                                                 <input type="hidden" name="_token" value="fk6s1vNZowD8Zow1RPG0T1nn1R2YgAi8606orijR">                                                
                                                                 <div class="modal-body">
                                                                    <div class="form-group">
                                                                       <label for="transactionId">Unique
                                                                       Transaction
                                                                       Reference <small style="color: red">*</small></label>
                                                                       <input type="text" class="form-control" name="referenceNo"  [(ngModel)]="referenceNo" [ngModelOptions]="{standalone: true}" id="transactionId" placeholder="6 to 12 Digit UTR Number">
                                                                    </div>
                                                                    <div class="form-group">
                                                                       <label for="proofOfDeposit162225">Upload Your
                                                                       Payment
                                                                       Proof <small style="color: red">[Required]</small></label>
                                                                       <input type="file" class="form-control" name="deposit_proof" (change)="processFile($event.target)" *ngIf="file == undefined" id="proofOfDeposit162225">
                                                                       <img id="blah" [src]="imageSrc || ''" style="width: 300px;" alt="your image" *ngIf="file != undefined">
                                                                      </div>
                                                                    <div class="form-group">
                                                                       <label for="exampleFormControlInput1">Amount
                                                                       <small style="color: red">*</small></label>
                                                                       <input type="number" [(ngModel)]="amount" [ngModelOptions]="{standalone: true}" class="form-control" name="amount" readonly="" value="100" id="amount162225Input" placeholder="Enter amount">
                                                                      
                                                                    </div>
                                                                    <input type="hidden" id="accountId" name="account_id" value="162225">
                                                                    <div class="custom-control custom-checkbox">
                                                                       <input type="checkbox" class="custom-control-input" name="terms_condition" id="termsCheck162225">
                                                                       <label class="custom-control-label" for="termsCheck162225">I
                                                                       have read and agree with <a href="javascript:void(0)" data-toggle="modal" data-target="#termsAndCondition" class="terms-condition">the
                                                                       terms of payment and withdrawal
                                                                       policy.</a></label>
                                                                    </div>
                                                                 </div>
                                                                 <div class="modal-footer">
                                                                    <button (click)="paymentDeposit()" type="submit" id="depositBtn" class="btn btn-info depositBtn" data-id="162225" data-original-title="" title="">
                                                                    Submit
                                                                    </button>
                                                                 </div>
                                                              </form>
                                                           </div>
                                                        </div>
                                                     </div>
                                                     <div class="loading-div loading-bank-account-162225" style="display: none">
                                                        <div class="loading"></div>
                                                     </div>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                        
                                      </div>
                                     
                                         
                                   </div>
                                 </div>
                                 <div class="row">
                                    <div class="col-md-12">
                                       <div class="card">
                                          <div class="card-body text-left" style="font-size: 10px !important;color: red;">
                                             <p>1. Deposit money only in the below available accounts to get the fastest
                                                credits
                                                and avoid possible delays.
                                             </p>
                                             <p>2. Deposits made 45 minutes after the account removal from the site are
                                                valid
                                                &amp; will be added to their wallets.
                                             </p>
                                             <p>3. Site is not responsible for money deposited to Old, Inactive or Closed
                                                accounts.
                                             </p>
                                             <p>4. After deposit, add your UTR and amount to receive balance. </p>
                                             <p>5. NEFT receiving time varies from 40 minutes to 2 hours. </p>
                                             <p>6. In case of account modification: payment valid for 1 hour after
                                                changing account details in deposit page. 
                                             </p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="col-md-4">
                           <div class="account-table">
                              <table class="table table-bordered account-table-new" id="depositTable">
                                 <thead>
                                    <tr>
                                       
                                       <th>Amount</th>
                                       <th>Status</th>
                                       <th>Date</th>
                                      
                                    </tr>
                                 </thead>
                                 <tbody id="depositTableData">
                                  <tr *ngFor="let statment of transsactionList">
                                     
                                     <td >{{statment.amount}}</td>
                                     <td >{{statment.approval_status}}</td>
                                     <td >{{statment.date|date:'medium'}}</td>
                                   
                                  </tr>
                               </tbody>
                                 <tbody id="depositTableData" *ngIf="transsactionList?.length==0">
                                    <tr id="no_data_found">
                                       <td colspan="5">No data found!</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>


                <!--end-->
                
              </div>
          </div>
      </div>
  </div>
</div>

<app-footer-main></app-footer-main>